import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getRevokeSoftDeletedEmployee = (
    token: string,
    backend: string,
    id: string,
) => {
    return fetch(
        `${getApiUrl(backend)}employees/revoke_soft_delete/${id}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default getRevokeSoftDeletedEmployee;
